import { render, staticRenderFns } from "./ProductManagementDetail.vue?vue&type=template&id=7131c225&scoped=true"
import script from "./ProductManagementDetail.vue?vue&type=script&lang=js"
export * from "./ProductManagementDetail.vue?vue&type=script&lang=js"
import style0 from "./ProductManagementDetail.vue?vue&type=style&index=0&id=7131c225&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7131c225",
  null
  
)

export default component.exports